import React from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../layout/AppShell";
import "./Dashboard.css";

export default function OverviewReadOnly() {
    const navigate = useNavigate();
    const loginName =
        (sessionStorage.getItem("tb_name") || "").trim() ||
        (sessionStorage.getItem("tb_email") || "").trim() ||
        "User";

    return (
        <AppShell activeKey="overview">
            <div className="ro-wrap">
                <section className="ro-hero">
                    <div className="ro-badge">Read Only Dashboard</div>
                    <h1 className="ro-title">Welcome {loginName}</h1>
                    <p className="ro-subtitle">Please go to AT&amp;T Onboarding Status for status check</p>
                    <div className="ro-actions">
                        <button type="button" className="ro-btn ro-btn-secondary" onClick={() => navigate("/att-status-check")}>
                            Open AT&amp;T Onboarding Status
                        </button>
                        <button type="button" className="ro-btn ro-btn-secondary" onClick={() => navigate("/help")}>
                            Open Help
                        </button>
                    </div>
                </section>

                <section className="ro-grid" aria-label="Read only quick information">
                    <article className="ro-card ro-card-status">
                        <h2>AT&amp;T Onboarding Status</h2>
                        <p>Use this section to check onboarding status quickly.</p>
                    </article>
                    <article className="ro-card ro-card-help">
                        <h2>Help</h2>
                        <p>Open guides and process details for TeamBridge workflows.</p>
                    </article>
                    <article className="ro-card ro-card-access">
                        <h2>Access</h2>
                        <p>Your role has view-only navigation to Dashboard, Status, and Help.</p>
                    </article>
                </section>
            </div>
        </AppShell>
    );
}
